module.exports = __webpack_public_path__ + "static/media/gmailImg.baadda60.png";